/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const MaxNumberOfFilesSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('MAX_NUMBER_OF_FILES')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class MaxNumberOfFilesSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return MaxNumberOfFilesSettingParser.decode(input).map(res => new MaxNumberOfFilesSetting(res));
    }
    static unsafeDecode(input) {
        return MaxNumberOfFilesSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return MaxNumberOfFilesSettingParser.encode(data);
    }
    static schema() {
        return MaxNumberOfFilesSettingParser.schema();
    }
}
